/**
 * Minimum API version for bulk operations.
 * This ensures bulk operation features work correctly across all operations.
 */
export const BULK_OPERATIONS_MIN_API_VERSION = '2026-01'
